// Example of how to use the new functions in a React component

import React, { useState, useEffect } from 'react';
import { useAppointmentsPG } from '../../hooks/useAppointmentsPG';
import ValueOverTimeChart from './ValueOverTimeChart';
import { useTranslations } from '../../hooks/useTranslations';

const AppointmentsTrendDashboard = () => {
  const { getMonthlyAppointmentsSummary, loading, error } = useAppointmentsPG();
  const [chartData, setChartData] = useState([]);
  const [chartLoading, setChartLoading] = useState(false);
  
  useEffect(() => {
    const loadChartData = async () => {
      try {
        setChartLoading(true);
        const data = await getMonthlyAppointmentsSummary();
        setChartData(data);
      } catch (error) {
        console.error('Failed to load chart data:', error);
        // Error is already handled by the hook
      } finally {
        setChartLoading(false);
      }
    };

    loadChartData();
  }, [getMonthlyAppointmentsSummary]);

  const t = useTranslations()

  if (chartLoading) {
    return <div className="p-6">{t.dashboard.loading}</div>;
  }

  if (error) {
    return (
      <div className="p-6 text-red-600">
        {t.charts.dashboard.errorLoadingData} {error}
      </div>
    );
  }

  return (
    <div className="">
      <ValueOverTimeChart data={chartData} />
    </div>
  );
};

export default AppointmentsTrendDashboard;